export default __webpack_public_path__ + "static/media/ico_lamp_light.e02e3b35.svg";